// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "signup-modal-island" + "." + "72a0d83d" + ".css";
};